import QuestionRemoveButton from "../QuestionRemoveButton";
import QuestionRestoreButton from "../QuestionRestoreButton";
import QuestionUpdateButton from "../QuestionUpdateButton";
import styles from "./styles.module.css"

export default function QuestionItem({ questionData, count, collectionRef, updateTableData }) {
    return (

        <div className={styles.optionsButtons}>
            <QuestionUpdateButton updateTableData={updateTableData} collectionRef={collectionRef} questionData={questionData} />
            {
                questionData.deleted
                    ?
                    <QuestionRestoreButton updateTableData={updateTableData} questionId={questionData.id} />
                    :
                    <QuestionRemoveButton updateTableData={updateTableData} questionId={questionData.id} />
            }
        </div>

    );
}